import { FireTeamType } from '../../../types';

export const isInComplete = (item: Partial<FireTeamType>): string => {
  const factionKeyword = item.factionKeyword || null;

  const filteredArray = [factionKeyword].filter((a) => a !== null);

  return filteredArray.join(', ');
};
